import axios from "axios";

export const uploadArticleUpdate = (file) => {
    const path = __API__ + '/api/sap/article/import';

    const config = {
        validateStatus: (status) => status === 200,
    };

    let formData = new FormData();
    formData.append('file', file);

    return axios.post(path, formData, config);
};


// WEBPACK FOOTER //
// ./src/admin/services/ArticleModule.js